module.exports = __webpack_public_path__ + "img/Dantam Fashion 14.ce2bfc2c.jpg";